import { useQuery } from "@apollo/client/react";import React, { useEffect, useMemo, useState } from 'react';

import { Grid } from '@mui/material';
import { TextInput } from '../../../../../components/textInput/TextInput';
import DataGridGenerico from '../../../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../../../components/dataGrid/columnHelpers';
import { CustomDialog } from "../../../../../components/customDialog/CustomDialog";
import { RenderInputsRowByType } from '../../../../../components/formGroupGenerator/RenderInputRowByType';
import { adaptTipoDocumentoArray, GET_ALL_TIPO_DOCUMENTO } from "../../../../../data/graphQL/queries/PacienteProbable/getAllTipoDocumento";
import moment from 'moment';

export const PacientesExistentes = ({
  input,
  handleChange,
  rows = [],
  totalCount,
  filterStatus,
  setFilterStatus,
  handleRowClick,
  esNuevoContrato
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [tiposDocumento, setTiposDocumento] = useState([]);

  const { data: dataTipoDocumento } = useQuery(GET_ALL_TIPO_DOCUMENTO);

  useEffect(() => {
    if (!dataTipoDocumento) return;
    setTiposDocumento(adaptTipoDocumentoArray(dataTipoDocumento));
  }, [dataTipoDocumento]);

  const buttonSettings = useMemo(() => ({
    ...input,
    disabled: !esNuevoContrato,
    onClick: () => handleOpenModal()
  }), [esNuevoContrato, input]);

  const handleOpenModal = () => setOpenModal(true);
  const handleClose = () => {
    setOpenModal(false);
  };

  const pacientesColumns = [
  {
    field: 'nombre',
    headerName: 'Nombre',
    flex: 0.13
  },
  {
    field: 'apellido',
    headerName: 'Apellido',
    flex: 0.13
  },
  {
    field: 'idTipoDocumento',
    headerName: 'Tipo Documento',
    flex: 0.13,
    valueGetter: (idTipoDocumento) => tiposDocumento.find((tipoDocumento) => tipoDocumento.id == idTipoDocumento)?.displayName
  },
  {
    field: 'numeroDocumento',
    headerName: 'Numero Documento',
    flex: 0.13
  },
  {
    field: 'sinDoc',
    headerName: 'Sin Doc',
    flex: 0.10
  },
  {
    field: 'sexo',
    headerName: 'Sexo',
    flex: 0.13
  },
  {
    field: 'fechaNacimiento',
    headerName: 'Fecha Nacimiento',
    flex: 0.13,
    valueGetter: (fechaNacimiento) => moment(fechaNacimiento).format('DD/MM/YYYY')
  }];

  const columns = useMemo(() => generateColumnsDefaultConfiguration(pacientesColumns), [pacientesColumns, tiposDocumento]);

  return <>
        <RenderInputsRowByType
      input={buttonSettings}
      value={null}
      handleChange={handleChange} />
    
        <CustomDialog
      maxWidth='lg'
      fullWidth
      onCancel={handleClose}
      open={openModal}
      cancelText='Cerrar'
      title='Pacientes Existentes'>
      
            <p>Haz click sobre un paciente para seleccionar sus datos.</p>
            <Grid
        container
        justifyContent={'space-between'}>
        
 <Grid sx={{ my: 2.5 }} size={{ xs: 12, md: 6 }}>
                    <TextInput
            placeholder='Filtrar'
            value={filterStatus}
            searchIcon
            onChange={(e) => setFilterStatus(e.target.value)}
            onClearButtonClick={() => setFilterStatus('')} />
          
                </Grid>
 <Grid size={{ xs: 12 }}>
                    <DataGridGenerico
            hideFooterPagination={false}
            toolbar={false}
            columns={columns}
            rows={rows}
            totalCount={totalCount}
            onRowClick={(row) => {
              handleRowClick(row);
              handleClose();
            }} />
          
                </Grid>
            </Grid>
        </CustomDialog>
    </>;
};